import React, { useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

// const openInNewTab = (url) => {
//   window.open(url, '_blank', 'noreferrer');
// };

const ButtonWorkshop = () => {
  return (
    <button
      onClick={() => {window.dispatchEvent(new CustomEvent("open-whatsapp-popup"));}}
      className="bg-defaultBlue text-white hover:bg-darkBlue hover:text-white focus:ring-4 focus:outline-none focus:ring-blue-300 font-semibold rounded-md text-sm md:text-base px-4 py-2"
    >
      Registration
    </button>
  );
};

const WorkshopCard = ({ title, title2, category, subtitle, date, activity, price, quota, backgroundImage }) => {
  return (
    <div className="max-w-md flex-none relative flex bg-center bg-cover mb-8 rounded-md overflow-hidden snap-start">
      <div className="w-full max-w-md">
        <img src={backgroundImage} alt="" className="w-full h-32 object-cover" />
        <div className="flex flex-col justify-between w-full relative z-10 p-4 bg-white">
          <h3 className="text-xl md:text-2xl font-semibold mb-1">{title}</h3>
          <h3 className="text-xl md:text-2xl font-semibold mb-1">{title2}</h3>
          <div className="h-0.5 w-full bg-defaultBlue mb-4 mt-4" />
          <p className="text-sm md:text-base">{category}</p>
          <p className="text-sm md:text-base mb-4">{subtitle}</p>
          <h3 className="text-base md:text-lg font-medium">{date}</h3>
          <p className="text-sm md:text-base mb-10">{activity}</p>
          <div className="grid grid-cols-2 items-center">
            <div>
              <ButtonWorkshop />
            </div>
            <div className="flex flex-col w-full text-end">
              <h1 className="text-lg md:text-xl font-bold text-red-500">{price}</h1>
              <p className="text-xs md:text-sm font-bold text-end ">{quota}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const SCROLL_FACTOR = 0.8;

export default function Workshop() {
  const containerRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: 'left' | 'right') => {
    const el = containerRef.current;
    if (!el) return;

    const amount = Math.round(el.clientWidth * SCROLL_FACTOR) * (direction === 'left' ? -1 : 1);
    el.scrollBy({ left: amount, behavior: 'smooth' });
  };

  return (
    <section id="workshop" className="relative bg-center bg-cover overflow-hidden sm:pb-8" style={{ backgroundImage: 'url("/images/workshop/workshop-bg.jpg")' }}>
      <div className="w-full h-full absolute bg-darkBlue bg-opacity-50 pointer-events-none" />
      <h2 className="text-3xl md:text-4xl font-semibold text-center mb-5 mt-5 text-white py-2 relative">Workshop</h2>

      <div className="relative container mx-auto px-4">
        <div
            ref={containerRef}
            className="
            flex flex-row items-start gap-4 px-2
            overflow-x-auto whitespace-nowrap snap-x snap-mandatory
            md:flex-wrap md:justify-center md:overflow-visible md:whitespace-normal
            scrollbar-hide
            "
        >
          <WorkshopCard
            title={'Artificial Intelligence (AI)'}
            title2={'Complete Package'}
            category={'For Elementary, Junior High, and Senior High School'}
            subtitle={'Basic to advance AI knowledge'}
            date={'6x meeting @6-8 hours on Saturday'}
            activity={'Hybrid Workshop for IIT Competition Preparation'}
            price={'IDR 9.800.000'}
            quota={'/school, max 10 person'}
            backgroundImage={'./images/workshop/workshop-programming3.webp'}
          />
          <WorkshopCard
            title={'C/C++/Python Complete Package'}
            title2={'Software Programming'}
            category={'For Junior and Senior High School'}
            subtitle={'Basic to advance C/C++/Python learning'}
            date={'6x meeting @6-8 hours on Saturday'}
            activity={'Hybrid Workshop for IIT Competition Preparation'}
            price={'IDR 9.800.000'}
            quota={'/school, max 10 person'}
            backgroundImage={'/images/workshop/workshop-programming1.webp'}
          />
          <WorkshopCard
            title={'C/C++/Python Exercise'}
            title2={'Software Programming'}
            category={'For Junior and Senior High School'}
            subtitle={'Who have C/C++/Python basic experience'}
            date={'2x meeting @6-8 hours on Saturday'}
            activity={'Hybrid workshop for IIT Competition Preparation'}
            price={'IDR 4.800.000'}
            quota={'/school, max 10 person'}
            backgroundImage={'/images/workshop/workshop-programming2.webp'}
          />
        </div>
        <button
            onClick={() => scroll('left')}
            className="absolute left-0 top-1/2 transform -translate-y-1/2 w-10 h-10 flex items-center justify-center rounded-full bg-defaultBlue text-white shadow-md z-10 md:hidden"
        >
            <FontAwesomeIcon icon={faChevronLeft} style={{ fontSize: '1.25rem' }} />
        </button>

        <button
            onClick={() => scroll('right')}
            className="absolute right-0 top-1/2 transform -translate-y-1/2 w-10 h-10 flex items-center justify-center rounded-full bg-defaultBlue text-white shadow-md z-10 md:hidden"
        >
            <FontAwesomeIcon icon={faChevronRight} style={{ fontSize: '1.25rem' }} />
        </button>
      </div>
    </section>
  );
}

